var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wenhao (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 17.9985168 0 17.9985168 18 0 18"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kepler-passport-\\u66F4\\u65B0",
    transform: "translate(-1304.000000, -1088.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wenhao-(1)",
    transform: "translate(1304.000000, 1088.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99856628,18 C4.02766364,18 -0.00148315792,13.9708532 -0.00148315792,9.00004944 C-0.00148315792,4.0291468 4.02766364,0 8.99856628,0 C13.96937,0 17.9985168,4.0291468 17.9985168,9.00004944 C17.9985168,13.9708532 13.96937,18 8.99856628,18 Z M8.99856628,14.0625865 C9.33207906,14.0625865 9.60263178,13.9545385 9.81081771,13.7391098 C10.0189048,13.5231125 10.123591,13.2559216 10.123591,12.9375618 C10.123591,12.6191031 10.019498,12.3570538 9.81081771,12.15176 C9.60263178,11.9458977 9.33207906,11.8333013 8.99856628,11.8125618 C8.56096054,11.8333013 8.23805234,12.028559 8.02986641,12.3980878 C7.82177935,12.7682099 7.82177935,13.1377387 8.02986641,13.5079596 C8.23805234,13.8774884 8.56096054,14.0625865 8.99856628,14.0625865 Z M9.86025631,10.3877167 C9.86025631,10.3230263 9.83776175,10.1374338 9.84055503,10.1638835 C9.8175908,9.92984114 9.84848993,9.72175408 9.97670893,9.52090978 C10.0700984,9.37412658 10.2146322,9.23624234 10.4306294,9.10859188 C11.7007811,8.35821285 12.1654298,7.52230505 12.1389801,6.65268012 C12.0995776,5.3499978 11.1399744,4.07136736 9.05870833,4.05282789 C7.31891466,4.03648843 6.17535046,4.87684571 5.90479774,6.45472798 C5.83835227,6.90790688 6.14561315,7.33129903 6.59703698,7.40864571 C7.04843609,7.48609127 7.47909571,7.18926194 7.56754136,6.73988981 C7.69076707,6.0255268 8.0907006,5.7313177 9.04298686,5.73982114 C10.087575,5.74936279 10.437971,6.21623618 10.4525554,6.70281086 C10.4562386,6.78641153 10.4338182,6.86917174 10.3884336,6.9395723 C10.2719809,7.14882116 10.019498,7.39186131 9.57289447,7.65566566 C9.13123476,7.91608347 8.79154215,8.24012876 8.55302564,8.61467557 C8.18233504,9.19693865 8.1013299,9.77292303 8.16438883,10.3584491 C8.17393048,10.4468205 8.17279339,10.4355238 8.17279339,10.3877167 C8.17133495,10.6901326 8.33181264,10.9702517 8.59349113,11.1218552 C8.85516963,11.2734586 9.17797895,11.2734586 9.43965745,11.1218552 C9.70123706,10.9702517 9.86171475,10.6901326 9.86025631,10.3877167 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.af45b7e88b2a677c6f631879d8ea786f.svg";
export { ForwardRef as ReactComponent };